var map = {
	"./amica-alt.svg": 5579,
	"./amica.svg": 5163,
	"./amicash_agency.jpg": 9218,
	"./background-10.jpg": 581,
	"./background-10.png": 3972,
	"./background-11.png": 6014,
	"./background-12.png": 6242,
	"./background-2.png": 3396,
	"./background-4.png": 376,
	"./background-5.png": 8626,
	"./background-6.png": 2576,
	"./background-7.png": 1874,
	"./background-8.png": 1378,
	"./background-9.png": 6188,
	"./bank_agent.jpg": 6493,
	"./banking_hall.jpg": 8556,
	"./chequebook.jpg": 7770,
	"./favicon.png": 4184,
	"./free_paybill.jpg": 7498,
	"./internal_chequebook.jpg": 4269,
	"./logo-alt.png": 2808,
	"./logo.png": 5080,
	"./membership_card.jpg": 8809,
	"./merchant_settlement.jpg": 522,
	"./mobile_banking.jpg": 4682,
	"./mpesa_services.jpg": 4866,
	"./paula paybill.png": 5438,
	"./paybill.jpg": 9736,
	"./pesalink.jpg": 7596,
	"./rtft.jpg": 1032,
	"./success.png": 6507,
	"./user.png": 8055,
	"./western_union.jpg": 5145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;